import { Component, input } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

import type { ArticleWithNullableRefs } from '../../../../types/types'

@Component({
  standalone: true,
  selector: 'dhp-article-type-badge',
  templateUrl: './article-type-badge.html',
  imports: [TranslatePipe],
})
export class ArticleTypeBadge {
  public readonly article = input.required<ArticleWithNullableRefs>()
}
